import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { EMPTY, of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CalendarService } from '../../../general/services/calendar.service';
import { BookingSlot } from '../../models/booking-slot';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';
import { BookingStepService } from '../../services/booking-step.service';

@Component({
  selector: 'app-time-slot-selector',
  templateUrl: './time-slot-selector.component.html',
  styleUrls: ['./time-slot-selector.component.css']
})
export class TimeSlotSelectorComponent implements OnInit, OnDestroy {
  faCaretLeft = faCaretLeft;
  faCaretRight = faCaretRight;

  @Input() calendarService: CalendarService;
  @Output() updatedBookingSlotEvent: EventEmitter<any> = new EventEmitter<any>();

  private _shiftSlotSubscription: Subscription;

  constructor(
    private bookingSlotStateService: BookingSlotStateService,
    private bookingStepService: BookingStepService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeShiftSlotSubscription();
  }

  get bookingSlots(): Array<BookingSlot> {
    return this.bookingSlotStateService.validBookingSlots;
  }

  get selectedSlot(): string {
    if (this.bookingSlotStateService.selectedSlot) {
      return this.bookingSlotStateService.selectedSlot.toString();
    }
    return 'No available slots';
  }

  onNextSlot(): void {
    this.shiftSlot(1);
  }

  onPrevSlot(): void {
    this.shiftSlot(-1);
  }

  shiftSlot(offset: number): void {
    const canShiftDate = this.bookingSlotStateService.canShiftDate;
    if (!canShiftDate) {
      return;
    }

    this._unsubscribeShiftSlotSubscription();
    this._shiftSlotSubscription = this.bookingStepService.canResetOrderQuestionPopup()
      .pipe(
        switchMap(
          canShift => {
            if (!canShift) {
              return EMPTY;
            }
            return this.bookingSlotStateService.shiftSlot(offset);
          }
        ),
        switchMap(
          result => {
            if (!result || this.bookingSlotStateService.selectedSlot == null) {
              return this.bookingSlotStateService.shiftNearestSlot(offset);
            }
            return of(true);
          }
        ),
      )
      .subscribe(
        _ => {
          this.updatedBookingSlotEvent.emit();
        }
      );
  }

  _unsubscribeShiftSlotSubscription(): void {
    if (this._shiftSlotSubscription) {
      this._shiftSlotSubscription.unsubscribe();
      this._shiftSlotSubscription = null;
    }
  }

  get showTimeSlotSwitches(): boolean {
    return this.bookingSlots && this.bookingSlots.length > 1;
  }

}
